// Mock data para Valuare JR

export const services = [
  {
    id: 1,
    number: "01",
    title: "Compra & Venda",
    description: "Relatórios de avaliação técnica conforme normas EVS (European Valuation Standards) para suporte à decisão em transações imobiliárias, incluindo análise comparativa de mercado e método do custo de reposição."
  },
  {
    id: 2,
    number: "02",
    title: "Crédito Habitação",
    description: "Avaliações imobiliárias certificadas para instituições financeiras, em conformidade com requisitos do Banco de Portugal e CMVM, aplicando metodologias reconhecidas de determinação de valor de mercado."
  },
  {
    id: 3,
    number: "03",
    title: "Heranças & Partilhas",
    description: "Avaliações periciais para processos sucessórios, partilhas entre co-herdeiros e desbloqueio de heranças indivisas, com fundamentação técnica para efeitos fiscais e judiciais."
  },
  {
    id: 4,
    number: "04",
    title: "Perícias Judiciais",
    description: "Relatórios periciais técnicos para tribunais, processos de divórcio, execuções fiscais e litigância imobiliária, elaborados por perito certificado com validação metodológica segundo normas TEGoVA."
  },
  {
    id: 5,
    number: "05",
    title: "Consultoria Técnica",
    description: "Assessoria especializada a construtores, promotores, investidores, mediadores imobiliários, consultores e proprietários privados, incluindo análise técnica de viabilidade, estudos de mercado e valorização de carteiras imobiliárias."
  },
  {
    id: 6,
    number: "06",
    title: "Avaliação para Investimento",
    description: "Análise técnica aprofundada para investidores institucionais e promotores, incluindo valuation de ativos, estudos de highest and best use e análise de cash-flow descontado (DCF)."
  }
];

export const credentials = [
  { id: 1, label: "Perito Registado CMVM", icon: "✦" },
  { id: 2, label: "Membro ANAI", icon: "✦" },
  { id: 3, label: "Normas EVS / TEGoVA", icon: "✦" },
  { id: 4, label: "Cobertura Nacional", icon: "✦" }
];

export const stats = [
  { id: 1, number: "CMVM", label: "PAI/2025/0020" },
  { id: 2, number: "ANAI", label: "Membro 1267" },
  { id: 3, number: "EVS", label: "Normas TEGoVA" },
  { id: 4, number: "PT", label: "Cobertura Nacional" }
];

export const contactInfo = {
  name: "José Rodrigo Riscado",
  role: "Administrador · Perito Avaliador",
  phone: "+351 915 964 080",
  emails: {
    general: "admin@valuarejr.com",
    admin: "joseriscado@valuarejr.com"
  },
  coverage: "Portugal Continental"
};
